// extracted by mini-css-extract-plugin
export var errorIcon = "_oc-1";
export var nameLogo = "_oc-0";